import type { ChartPayload } from '../api/types';
import { useApiState } from '../api/state';
import { Chart } from '../chart/Chart';
import { ApiStateText } from './ApiStateText';

export interface InstrumentProps {
  payload: ChartPayload | null;
  symbol: string;
  onSymbolChange: (symbol: string) => void;
  /** True when neither the recorded data nor the worker API could be loaded. */
  nothingLoaded: boolean;
}

const INST_NOTE = "Pool line: the basis monitor's reading of the largest pool for the token at each sample, about every 6.5 minutes, from Uniswap slot0 or DexScreener; the dashed prefix, where present, is GeckoTerminal's hourly close of the same pool before the monitor started. Feed line: every Chainlink round, stepped at its on-chain updatedAt. While the page is open the lines grow every 60 seconds from Chainlink (latestRoundData) and DexScreener; if a reading fails the chart keeps the recorded series and says so. Shaded: the feed's frozen windows from its session rule (Friday 20:00 ET to Sunday 20:00 ET, and market holidays); lighter: the NYSE cash session. Hover for the readings at any sample.";

export function Instrument({ payload, symbol, onSymbolChange, nothingLoaded }: InstrumentProps) {
  const api = useApiState();
  return (
    <section className="instrument" aria-labelledby="inst-title">
      <div className="inst-head">
        <h2 id="inst-title" className="sr-only">Pool price against the frozen oracle</h2>
        <Chart payload={payload} symbol={symbol} onSymbolChange={onSymbolChange} mode={api.mode} slot="picker" />
        <p className="inst-legend"><span className="key oracle"></span>Chainlink feed <span className="key pool"></span>Uniswap pool <span className="key gap"></span>the gap <span className="key frozen"></span>feed frozen <span className="key cash"></span>NYSE cash session</p>
      </div>
      <Chart payload={payload} symbol={symbol} onSymbolChange={onSymbolChange} mode={api.mode} slot="chart" />
      <p className="inst-api">Worker API: <ApiStateText /></p>
      <Chart payload={payload} symbol={symbol} onSymbolChange={onSymbolChange} mode={api.mode} slot="summary" />
      <p className="inst-note" id="inst-note">{nothingLoaded ? 'The recorded data could not be loaded.' : INST_NOTE}</p>
    </section>
  );
}
